import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { useEffect } from 'react';

export const useCKVariablesEvents = (
  handler: (arg: any, data?: any, input?: any) => void,
  editor?: Editor,
): void => {
  useEffect(() => {
    if (editor) {
      editor.on('variablesPopup', handler);
    }

    return () => {
      if (editor) {
        editor.off('variablesPopup', handler);
      }
    };
  }, [editor, handler]);
};
